import React, { useEffect, useState } from "react";
import RequestTable from "../../../Component/requestTable";
import Loader from "../../../Component/loader";
import { customErrorHandler, toTitleCase } from "../../../Utils/helper";
import { useAuth } from "../../../Utils/Auth";
import bankService from "../../../Services/apiService/bank-service";
import transactionService from "../../../Services/apiService/transaction-service";
import { toast } from "react-toastify";
import TransactionSercvice from "../../../Services/TransactionSercvice";

const AllTransactionRequests = () => {
  const auth = useAuth()
  const [requests, setRequests] = useState([]);
  const [selectedType, setSelectedType] = useState("");

  console.log("requests", selectedType)
  const [paginationData, setPaginationData] = useState({
    page: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 10,
  });

  const [isLoading, setIsLoading] = useState(false);
  const startIndex = Math.min(
    (paginationData.page - 1) * paginationData.limit + 1
  );
  const endIndex = Math.min(
    paginationData.page * paginationData.limit,
    paginationData.totalItems
  );


  const fetchData = async (page) => {
    try {
      setIsLoading(true)
      const res = await transactionService.getTransactionDeleteRequest(auth.user, page || paginationData.page, paginationData.limit);
      if (res) {
        const data = res?.data?.data?.map((item) => ({
          ...item,
          createdAt: new Date(item.createdAt)
            .toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })
            .replace(/am|pm/i, (match) => match.toUpperCase()),
          //For Future Use
          //   updatedAt: new Date(item.updatedAt).toLocaleString("en-IN", {
          //     timeZone: "Asia/Kolkata",
          //     day: "2-digit",
          //     month: "2-digit",
          //     year: "numeric",
          //     hour: "2-digit",
          //     minute: "2-digit",
          //     second: "2-digit",
          //     hour12: true,
          //   }),
        }));
        setRequests(data)
        setPaginationData((state) => ({
          ...state,
          page: res?.data?.pagination?.page,
          totalPages: res.data?.pagination?.totalPages,
          totalItems: res.data?.pagination?.totalItems,
          limit: res.data?.pagination?.limit,
        }));
      }
    }
    catch (err) {
      toTitleCase(customErrorHandler(err.message, "Something went wrong"));
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [selectedType])

  const handleApprove = async (data) => {
    setIsLoading(true)
    switch (data.transactionType) {
      case "Deposit":
      case "Withdraw":
        transactionService.transactionMoveToTrash(data.id, auth.user)
          .then((response) => {
            toast.success(response.data.message);
            fetchData()
          })
          .catch((error) => {
            toast.error(customErrorHandler(error));
          });
        break;
      case "Manual-Website-Withdraw":
      case "Manual-Website-Deposit":
        transactionService.websiteTransactionMoveToTrash(data.id, auth.user)
          .then((response) => {
            toast.success(response.data.message);
          })
          .catch((error) => {
            toast.error(customErrorHandler(error));
          });
        break;
      case "Manual-Bank-Withdraw":
      case "Manual-Bank-Deposit":
        transactionService.bankTransactionMoveToTrash(data.id, auth.user)
          .then((response) => {
            toast.success(response.data.message);
            fetchData()
          })
          .catch((error) => {
            toast.error(customErrorHandler(error));
          });
        break;
      default:
        break;
    }
    setIsLoading(false)
  };

  const handleReject = async (data) => {
    try {
      setIsLoading(true)
      const res = await transactionService.rejectTransactionDelete(data.id, auth.user);
      toast.success(toTitleCase(res?.data?.message));
      await fetchData();
    } catch (error) {
      toTitleCase(customErrorHandler(error))
    }
    setIsLoading(false)
  };

  const pageHandler = (selectedPage) => {
    fetchData(selectedPage);
  };

  return (
    <div className="container">
      <RequestTable
        data={requests}
        columns={[
          { field: 'createdAt', headerName: 'Date & Time' },
          { field: 'subAdminName', headerName: 'Requester', },
          { field: 'bankName', headerName: 'Bank Name' },
          { field: 'websiteName', headerName: 'Website Name' },
          { field: 'transactionType', headerName: 'Transaction Type', },
          { field: 'amount', headerName: 'Amount' },
        ]}
        requestTypes={[{ option: 'Bank Transaction', value: 'New' }, { option: 'Website Transaction', value: 'Edit' }, { option: 'Upcoming', value: 'Delete' }]} // obj make type+value
        onApprove={handleApprove}
        onReject={handleReject}
        title="Transaction Delete Requests"
        filter={{ isFilterDropDownShow: false, isFilterSearchShow: true }}
        page={paginationData.page}
        totalPage={paginationData.totalPages}
        startIndex={startIndex}
        endIndex={endIndex}
        totalData={paginationData.totalItems}
        onPageChange={pageHandler}
        setSelectedType={setSelectedType}
        selectedType={selectedType}
      />
      <Loader
        isLoading={isLoading}
        spinnerType="bar"
        color="#ff5722"
        message="Processing..."
      />
    </div>
  );
};


export default React.memo(AllTransactionRequests);